import type { BillingEstimate, BillingEstimateParams } from '@core/billing-types';
import type { PickActions } from '@core/ngrx-legacy';
import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

const { actions, namespace, reducer, selectors } = createSingleEntityStore<BillingEstimate>()(
  'BillingEstimate',
  {
    customActions: adapter => ({
      fetch: (state, payload: BillingEstimateParams) =>
        pipeState(adapter.reset(), next => adapter.markAsPending(next)),
    }),
  },
);

const BillingEstimateActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  BillingEstimateActions,
  namespace as BillingEstimateNamespace,
  reducer as BillingEstimateReducer,
  selectors as BillingEstimateSelectors,
};
